interface LogoProps {
  className?: string;
  /** brand = accent wordmark (default), light = warm peach (e.g. footer). */
  tone?: 'brand' | 'light';
  /** Wordmark text — defaults to BYAFT. */
  label?: string;
}

/**
 * The BYAFT wordmark with a glowing accent "core" dot. The colour follows the
 * themeable brand accent (orange on byaft.com / tools, neon green on cyber).
 */
export function Logo({ className = '', tone = 'brand', label = 'BYAFT' }: LogoProps) {
  const color = tone === 'light' ? 'text-primary-fixed-dim' : 'text-primary-container';
  return (
    <span
      className={`inline-flex items-end font-display text-[1.6rem] font-extrabold leading-none tracking-tightest ${color} ${className}`}
    >
      {label}
      <span
        className="ml-[0.12em] mb-[0.18em] h-[0.28em] w-[0.28em] rounded-full bg-primary-container shadow-glow-sm motion-safe:animate-glow-pulse"
        aria-hidden="true"
      />
    </span>
  );
}
